@if (eventModel && eventModel.OrganizationId) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <control-linkable
            #linkableControls
            typename="controls"
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [orderByValueProperty]="true"
            [disabled]="disabled"
            (linkedChange)="linkedItemsChanged($event)"
            (onLinkedClick)="editLinked($event)"
            (onBatchClicked)="openBatchEdit()"
        >
        </control-linkable>
    }
}
